import React from 'react';
import styled from 'styled-components';
import Button from '@gcc/pip-components/dist/Button';
import thdCustomer from '../utils/thdCustomer';
import getThdStoreInfo from '../utils/getThdStoreInfo';
import { getConfig } from '../config';
import Advisory from '../common/icons/Advisory';

const InfoBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 20px;
`;

const InfoIcon = styled.div`
  color: #8f6e2e;
  flex-shrink: 1;
  // img {
  //   width: 17px;
  //   height: 17px;
  // }
  margin-top: -3px;
`;

const InfoText = styled.div`
  color: #8f6e2e;
  flex-grow: 1;
  padding-left: 5px;
`;

const InfoNotAvailable = () => {
  const storeInfo = getThdStoreInfo();
  const { storeNumber } = storeInfo;

  // eslint-disable-next-line max-len
  let url = `https://hdapps.homedepot.com/ApptMakerOnline/custAppt.jsp?deptNbr=${getConfig()?.thdDepartmentNumber}&prdctTyp=${getConfig()?.thdProductTypeId}`;
  if (storeNumber) {
    url = `${url}&storeNo=${storeNumber.toString().padStart(4, '0')}`;
  }
  if (thdCustomer.isLoggedIn) {
    url = `${url}&email=${thdCustomer.email}`;
  }

  return (
    <div>
      <InfoBlock>
        <InfoIcon><Advisory /></InfoIcon>
        <InfoText>
          <strong>Warning!</strong>
          {' '}
          We’re having difficulty locating information for your area.
          Check back soon or schedule an in-store appointment with a Kitchen Designer to begin your estimate.
        </InfoText>
      </InfoBlock>
      {/*
        <Button
          className="primary bttn-primary-pip"
          onClick={() => { window.location = url; }}
        >
          Schedule Appointment
        </Button>
      */}
    </div>
  );
};

export default InfoNotAvailable;
